import { render, staticRenderFns } from "./ReportingSocial.vue?vue&type=template&id=cb54932e&scoped=true&"
import script from "./ReportingSocial.vue?vue&type=script&lang=js&"
export * from "./ReportingSocial.vue?vue&type=script&lang=js&"
import style0 from "./ReportingSocial.vue?vue&type=style&index=0&id=cb54932e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb54932e",
  null
  
)

export default component.exports